import { render } from "./ObjectiveId.vue?vue&type=template&id=64d41864&scoped=true"
import script from "./ObjectiveId.vue?vue&type=script&lang=js"
export * from "./ObjectiveId.vue?vue&type=script&lang=js"

import "./ObjectiveId.vue?vue&type=style&index=0&id=64d41864&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d41864"]])

export default __exports__